import { Component, AfterViewInit, OnInit, OnDestroy, NgZone, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
} from '@covalent/core';

import { Patron } from '../../../../models';

import { PatronesService, LoginService, } from '../../../../services/';

@Component({
  selector: 'qs-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
  viewProviders: [PatronesService],
})
export class TestComponent implements AfterViewInit, OnInit, OnDestroy {

  private idPaciente: string;
  private patrones: Patron[];

  private _xsScreen: Subscription;

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'idPatron', label: 'ID', hidden: true },
    { name: 'textoPatron', label: 'Título', tooltip: 'Título', sortable: true },
    { name: 'fechaCumplimentacion', label: 'Fecha cumplimentación', tooltip: 'Fecha cumplimentación', sortable: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: Patron[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  @ViewChild(TdDataTableComponent) tableComponent: TdDataTableComponent;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _patronesService: PatronesService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.watchScreen();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('test.load');
    this._patronesService.obtenerListadoValoracionesPaciente(
      5,
      this._loginService.consulta.numeroExpediente,
      true,
    ).subscribe((res: any) => {
      this.patrones = res.respuesta;
      this.filteredData = this.patrones;
      this.filteredDataTotal = this.patrones.length;
      this._loadingService.resolve('test.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo motivos de consulta.', 'OK', 6000);
      this._loadingService.resolve('test.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.watchScreen();
  }

  /**
   * watchScreen:
   * Observable de cambio de resolució. Oculta o muestra columnas
   * xs < 600px
   * sm > 600px
   * md < 1280px
   */
  watchScreen(): void {
    this._xsScreen = this.media.registerQuery('xs').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          this.columns[0].hidden = true;
        } else {
          this.columns[0].hidden = false;
        }
      });
    });
  }

  openDetalleAlta(): void {
    this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/modanamnesis',
    { outlets: { modanamnesis: ['testdisponibles'] } }]);
  }

  /**
   * openDetalle: Muestra la vista de detalle pasando la linea seccionada
   * @param any: $event <- Fila seleccionada
   */
  openDetalle(patron: Patron): void {
    if (patron) {
      this._loginService.transient = patron;
      this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/modanamnesis',
      { outlets: { modanamnesis: ['testdetalle'] } }]);
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.patrones;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  ngOnDestroy(): void {
    this._xsScreen.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/test/test.component.ts